import { __decorate } from "tslib";
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import _ from 'lodash';
import formatNumber from '@cores/utils/formatNumber';
let NodeListRepositoryImpl = class NodeListRepositoryImpl {
    parseNodesApiResult(data) {
        let nodeList = [];
        if (data.field_type === 'OPTION') {
            nodeList = this._parseOptionData(data.field_option_value, data.smart_field_item_count);
        }
        else {
            nodeList = this._parseLayerData(data.field_layer_value, data.smart_field_item_count);
        }
        return nodeList;
    }
    _getCountById(data, id) {
        return _.get(data, id, 0);
    }
    _getCountString(count) {
        return formatNumber(count);
    }
    _spliceName(name) {
        if (name.length >= 40) {
            return `${name.slice(0, 40)}...`;
        }
        return name;
    }
    _parseLayerData(field_layer_value, smart_field_item_count) {
        return _.map(field_layer_value, (item) => {
            const count = this._getCountString(this._getCountById(smart_field_item_count, item.id));
            return {
                id: item.id,
                name: this._spliceName(item.name),
                isReady: true,
                count,
                children: this._parseLayerData(item.children, smart_field_item_count),
            };
        });
    }
    _parseOptionData(option_value, smart_field_item_count) {
        return _.map(option_value, (item) => {
            const count = this._getCountString(this._getCountById(smart_field_item_count, item.option_id));
            return {
                id: item.option_id,
                name: this._spliceName(item.option_text),
                isReady: true,
                count,
            };
        });
    }
};
NodeListRepositoryImpl = __decorate([
    injectable()
], NodeListRepositoryImpl);
export { NodeListRepositoryImpl };
